import moment from 'moment';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

export default function BatchDeliveryDetailItem({ data, isIndividualMode, isChecked, onCheckChanged, onDelete }) {
  return (
    <div className="w-full h-full relative shadow-center rounded-[12px] p-4 my-4">
        {isIndividualMode && (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => onCheckChanged(data._id, e.target.checked)}
            className="absolute top-4 right-4 w-6 h-6 accent-blue-500 cursor-pointer"
          />
        )}
        <div className="flex gap-2 items-center">
          <div className="bg-gray-base rounded-[34px] text-subtitle px-3 py-1 text-sm">検体No</div>
          <div className="text-sm">{data.inspectionKitId || ''}</div>
          {data.salonDeliverStatus === 'pending' && !isIndividualMode && (
            <div
              className="pl-4 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            >
              <FontAwesomeIcon icon={faTrash} color="#CACACA" />
            </div>
          )}
        </div>
      <div className="flex gap-2 mt-3 items-center text-sm">
        <div>{data.customerName || ''}</div>
      </div>
      <div className="flex gap-2 mt-3 pt-3 items-center justify-between text-xs text-subtitle border-t border-[#EDEDED]">
        <div>お客様No. {data.customerNo || ''}</div>
        <div>登録日時： {data.createdAt !== undefined ? moment(data.createdAt).format('YYYY-MM-DD HH:mm') : '-'}</div>
      </div>
    </div>
  );
}
